import { Input } from 'component/Input'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { demo } from 'page/catalog/store/CatalogStore'
import { userModal } from 'page/catalog/UserModal/store/UserModalStore'

export const SearchInput = observer(() => {
  const be = demo.it.by_email
  const bc = demo.it.by_card
  const store = userModal.it
  const { search } = store
  const label = i18n('CustomerSearch')
  const placeholder = be ? i18n('CustomerEmail') : bc ? i18n('EnterClientId') : i18n('CustomerPhoneNumber')

  const onChange = useLatestCallback((value: string) => {
    if (bc) value = value.replaceAll(/\D/g, '')
    search.change(value)
  })

  const onEnter = useLatestCallback(async () => {
    search.enter()
  })

  return <Vertical gap={8}>
    <Typo size={11} medium upper>
      {label}
    </Typo>
    <Input height={48} value={search.text} autofocus
      onChange={onChange} onEnter={onEnter} placeholder={placeholder} />
  </Vertical>
})
